import { render } from "./ConfirmationPage.vue?vue&type=template&id=d43313fe&scoped=true"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js"

import "./ConfirmationPage.vue?vue&type=style&index=0&id=d43313fe&scoped=true&lang=css"
import "./ConfirmationPage.vue?vue&type=style&index=1&id=d43313fe&scoped=true&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d43313fe"]])

export default __exports__